<template>
	<q-dialog v-model="myeditmodal" transition-show="fade" transition-hide="fade">
		<div class="hris-modal hris-modal-lg">
			<div class="hris-modal-header">
				<div>
					<h2 class="hris-modal-title">Edit Announcement</h2>
					<p class="hris-modal-subtitle">Update the announcement details below.</p>
				</div>
				<q-btn flat dense round v-close-popup aria-label="Close">
					<i class="fas fa-times"></i>
				</q-btn>
			</div>
			<div class="hris-modal-body">
				<div class="hris-form-row">
					<div class="hris-form-field" style="flex-basis: 100%;">
						<q-input outlined dense color="green" label="Subject" v-model="subject" ref="subj" :rules="[val => !!val || 'Subject is required']"></q-input>
					</div>
				</div>
				<div class="hris-form-row">
					<div class="hris-form-field" style="flex-basis: 100%;">
						<q-input outlined dense color="green" label="Body" v-if="fullMesg != ''" ref="message" v-model="fullMesg" type="textarea" :rules="[val => !!val || 'Body is required']"></q-input>
						<q-input outlined dense color="green" label="Body" v-else v-model="message" ref="message" type="textarea" :rules="[val => !!val || 'Body is required']"></q-input>
					</div>
				</div>
				<div class="hris-form-row">
					<div class="hris-form-field" style="flex-basis: 100%;">
						<q-file outlined dense color="green" v-model="file" id="file" label="Pick one file" ref="file" accept="image/*,.pdf" :rules="[val => !!val || 'Attachment is required']">
							<template v-slot:prepend>
								<i class="fas fa-paperclip"></i>
							</template>
						</q-file>
					</div>
				</div>
			</div>
			<div class="hris-modal-footer">
				<q-btn unelevated class="hris-q-outline" label="Close" v-close-popup></q-btn>
				<q-btn unelevated class="hris-q-primary" label="Update" type="submit" @click="updateAnnouncement"></q-btn>
			</div>
		</div>
	</q-dialog>
</template>

<script>
   import axios from 'axios';
   import mixins from '../../mixins';
export default {
   data () {
	   return {
		 myeditmodal: false,
		 id: '',
		 subject : '',
		 message: '',
		 attachment: '',
		 dateCreated: '',
		 created_by: '',
		 fullMesg: '',
		 file: null,
		 text: '',
		 dense: false,
		 selectedFile: null
	   }
   },

   created() {
	   this.eventHub.$on('openEditModal', this.openEditModal);
   },

   methods: {
	   openEditModal:function(props){
		   this.myeditmodal = props.stat;
		   this.id = props.obj.id;
		   this.subject = props.obj.subject;
		   this.message = props.obj.message;
		   this.attachment = props.obj.attachment;
		   this.dateCreated = props.obj.date_created;
		   this.created_by = props.obj.created_by;
		   this.fullMesg = props.obj.full_message;
		   //this.file = props.obj.attachment;
		   console.log(props)
	   },
	   pickFile() {
		   this.file = this.$refs.file.files[0];
	   },

	   onUpload(){
		   let formData = new FormData();
		   formData.append("file", this.file, this.file.name);
		   axios.post('/announcement/file',formData)
		   .then(res => {
			   console.log("res", res);
		   });
	   },

	   updateAnnouncement:function(){
		   this.spinner=true;
		   let formData = new FormData();
		   // START:: 11-03-2020 NICELE 11:36AM
		   this.$refs.subj.validate()
		   this.$refs.message.validate()
		   this.$refs.file.validate()

		   if (this.$refs.subj.hasError || this.$refs.message.hasError || this.$refs.file.hasError) {
			   this.formHasError = true
		   }else {
			   formData.append("id", this.id);
			   formData.append("subject", this.subject);

			   if(this.fullMesg == ''){
				   formData.append("fullMesg", this.message);
			   }else{
				   formData.append("fullMesg", this.fullMesg);
			   }
			   formData.append("file", this.file);
			   console.log("this.file: ",this.file);
			   axios.create({
				   baseURL : this.apiUrl,
				   headers : {'Authorization' : `Bearer ${this.token}`}
			   }).post('/announcement/update',formData)
			   .then((res) => {
				   console.log(res.data);
				   this.myeditmodal = false;
				   this.eventHub.$emit('updatedAnnouncement');

				   this.$q.notify({
					 position: 'center',
					 color: 'positive',
					 message: 'Updated'
				   })
			   });
		   }
		   // END:: 11-02-2020 NICELE 6:33PM
	   },

   }

}
</script>
